import { render, staticRenderFns } from "./SetPortalSignUpForm.vue?vue&type=template&id=b171a0d0&"
import script from "./SetPortalSignUpForm.vue?vue&type=script&lang=js&"
export * from "./SetPortalSignUpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b171a0d0')) {
      api.createRecord('b171a0d0', component.options)
    } else {
      api.reload('b171a0d0', component.options)
    }
    module.hot.accept("./SetPortalSignUpForm.vue?vue&type=template&id=b171a0d0&", function () {
      api.rerender('b171a0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/clients/client-manage/SetPortalSignUpForm.vue"
export default component.exports